const dropdown = function () {
	const sideNav = document.querySelector(".side-nav ul");

	const subNavs = sideNav.querySelectorAll(".menu-item-has-children > a");
	subNavs.forEach((nav) => {
		const toggleBtn = document.createElement("span");
		toggleBtn.innerText = "+";
		toggleBtn.classList.add("toggle-btn");
		nav.parentNode.insertBefore(toggleBtn, nav);
		const childNav = nav.parentNode.querySelector(".sub-menu");
		toggleBtn.addEventListener("click", function () {
			if (childNav.classList.contains("sub-menu--visible")) {
				childNav.classList.remove("sub-menu--visible");
				toggleBtn.classList.remove("opened");
			} else {
				childNav.classList.add("sub-menu--visible");
				toggleBtn.classList.add("opened");
			}
		});
	});
};

const responsiveTable = function () {
	const tables = document.querySelectorAll("table");
	tables.forEach((table) => {
		if (
			table.classList.contains("table-top") ||
			table.classList.contains("table-both")
		) {
			const row1 = table.querySelector("tr");
			var headings = row1.querySelectorAll("td");

			for (var i = 0; i < headings.length; i++) {
				const column = table.querySelectorAll(`td:nth-child(${i + 1})`);
				column.forEach((cell) => {
					cell.dataset.heading = headings[i].innerText;
				});
			}
		}
		if (
			table.classList.contains("table-left") ||
			table.classList.contains("table-both")
		) {
			const leftHeadings = table.querySelectorAll(`tr > td:first-child`);
			const rows = table.querySelectorAll(`tr`);
			leftHeadings.forEach((cell) => {
				cell.classList.add("left-header");
			});

			for (var i = 0; i < leftHeadings.length; i++) {
				rows[i].dataset.heading = leftHeadings[i].innerText;
			}
		}
	});
};

const closeTabs = function () {
	const tabs = document.querySelectorAll(".accordionBody");
	tabs.forEach((tab) => {
		tab.style.display = "none";
	});
};

const imageSlider = function () {
	const slider = document.querySelector(".imageSlider__inner");
	const slides = slider.querySelectorAll("img");
	const prevBtn = document.querySelector(".imageSlider__prev");
	const nextBtn = document.querySelector(".imageSlider__next");
	slides[0].classList.add("focused");
	for (var i = 0; i < slides.length; i++) {
		slides[i].dataset.order = `${i}`;
	}

	function movePrev() {
		const current = slider.querySelector(".focused");
		const next = parseInt(current.dataset.order) - 1;
		const nextSlide = slider.querySelector(`[data-order="${next}"]`);
		if (next == -1) {
			const last = slides.length - 1;
			const moveBy = last * -100;
			slider.style.transform = `translateX(${moveBy}%)`;
			slides[last].classList.add("focused");
			current.classList.remove("focused");
		} else {
			const moveBy = next * -100;
			slider.style.transform = `translateX(${moveBy}%)`;
			nextSlide.classList.add("focused");
			current.classList.remove("focused");
		}
	}

	function moveNext() {
		const current = slider.querySelector(".focused");
		const next = parseInt(current.dataset.order) + 1;
		const nextSlide = slider.querySelector(`[data-order="${next}"]`);
		if (next == slides.length) {
			slider.style.transform = `translateX(0%)`;
			slides[0].classList.add("focused");
			current.classList.remove("focused");
		} else {
			const moveBy = next * -100;
			slider.style.transform = `translateX(${moveBy}%)`;
			nextSlide.classList.add("focused");
			current.classList.remove("focused");
		}
	}

	prevBtn.addEventListener("click", movePrev);
	nextBtn.addEventListener("click", moveNext);
};

const popup = function () {
	const popupBtn = document.querySelector(".js-popup-trigger");
	const popup = document.querySelector(".js-popup");
	const closeBtn = document.querySelector(".js-popup-close");

	popupBtn.addEventListener("click", function () {
		popup.classList.remove("hide");
	});

	closeBtn.addEventListener("click", function () {
		popup.classList.add("hide");
	});
};

window.addEventListener("load", dropdown);
window.addEventListener("load", responsiveTable);
window.addEventListener("load", closeTabs);
window.addEventListener("load", imageSlider);
window.addEventListener("load", popup);
